import React, { useEffect, useRef, useState } from "react";
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from "react-router-dom";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "32px 16px 48px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "18px 16px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  badge: {
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    padding: "6px 12px",
    borderRadius: "999px",
    fontWeight: 800,
    fontSize: "12px",
    display: "inline-block",
    border: "1px solid rgba(255,255,255,0.12)",
  },
  title: {
    margin: 0,
    fontSize: "26px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    margin: 0,
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.5,
  },
  tagRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  tag: {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "10px",
    padding: "8px 10px",
    fontWeight: 700,
    color: "#f8fafc",
    fontSize: "13px",
  },
};

export default function SinglePage() {
  const [cookies] = useCookies(['uuid']);
  const [socketData, setSocketData] = useState(null); // ✅ 여기서 setSocketData 선언

  // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
  const[uid,setUID] = useState(0);
  const[nickname,setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [grade,setGrade] = useState('normal');
  const [ex_period,setExperiod] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  const [isTradingETH, setIsTradingETH] = useState(false); // 자동매매 상태
  const [isTradingXRP, setIsTradingXRP] = useState(false); // 자동매매 상태
  const [isTradingSOL, setIsTradingSOL] = useState(false); // 자동매매 상태
  const [isTradingDOGE, setIsTradingDOGE] = useState(false); // 자동매매 상태

  const [statusTextETH, setStatusTextETH] = useState("ETH 매매종료중"); // 기본 상태
  const [statusTextXRP, setStatusTextXRP] = useState("XRP 매매종료중"); // 기본 상태
  const [statusTextSOL, setStatusTextSOL] = useState("SOL 매매종료중"); // 기본 상태
  const [statusTextDOGE, setStatusTextDOGE] = useState("DOGE 매매종료중"); // 기본 상태

  const [symbol,setSymbol] = useState('default');
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmStop, setShowConfirmStop] = useState(false);
  const [showConfirmStopYes, setShowConfirmStopYes] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(''); // 여기서 메시지 관리

  const [eth_usdt,setEthUsdt] = useState(0);
  const [xrp_usdt,setXrpUsdt] = useState(0);
  const [sol_usdt,setSolUsdt] = useState(0);
  const [doge_usdt,setDogeUsdt] = useState(0);

  const [eth_check,setEthCheck] = useState('no')
  const [xrp_check,setXrpCheck] = useState('no')
  const [sol_check,setSolCheck] = useState('no')
  const [doge_check,setDogeCheck] = useState('no')

  // const[margin,setMargin] = useState('');

  // ✅ 권한 확인
  const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          setUID(user.uid);
          setNickname(user.nickname);
          setEmail(String(user.email ?? ''));
          setGrade(user.grade);
          setExperiod(user.ex_period);
          const possible = user.web_possible;
          const nickname = user.nickname;
          const grade = user.grade;
          const ex_period = user.ex_period;

          if (possible === '0' || possible === null || possible === 0){
            alert(`${nickname} 님은 WEB version의 사용권한이 없습니다.`)
            navigate("/SelectPage");
            } 
          
          
          let today = new Date();  // 현재 날짜 가져오기
          let targetDate = new Date(ex_period);  // 비교할 날짜를 Date 객체로 변환
          // 두 날짜의 차이(밀리초)를 구한 후, 일 단위로 변환
          let timeDiff = targetDate - today;
          // 남은 일, 시간, 분 계산
          let daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          let hoursLeft = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          // 남은 기간이 5일 이하이면 팝업 표시
          if (timeDiff > 0 && daysLeft <= 5) {
              alert(`사용기한이 ${daysLeft}일 ${hoursLeft}시간 ${minutesLeft}분 남았습니다.\n` +
              `----------------------------------------------------------------------\n` +
              `※ 사용기한이 지나면 자동으로 종료됩니다.\n`+
              `※ 더이상 프로그램 사용을 원치 않으시면 진입중인 포지션은 미리 정리해주세요!\n`+
              `※ 정리하지 않은 포지션은 더이상 자동으로 포지션을 잡거나 정리하지 않습니다.`)
          } else if (timeDiff <= 0) {
              alert("사용기한이 만료되었습니다.");
              navigate("/SelectPage");
          }
        })
        .catch(error => {
          alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
          navigate("/LoginAts", { replace: true });
        });
    };

  // ✅ uuid / 경로 변경될 때마다 권한 체크
  useEffect(() => {
    if (!cookies.uuid) {
      alert("로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
      navigate("/LoginAts", { replace: true });
    } else {
      fetchUserInfo(cookies.uuid);
    }
  }, [cookies.uuid, location.pathname]);

    
  const wsRef = useRef(null); // 중복 생성 방지

  useEffect(() => {
    if (!uid) return; // uid가 없으면 실행하지 않음

    const host = window.location.hostname;
    const isLocal = host === "127.0.0.1" || host === "localhost";
    const WS_URL = isLocal
      ? "ws://127.0.0.1:8000/ws"
      : "wss://xtaibot.com/ws";

    let reconnectTimer;
    let isUnmounted = false;

    const connectWebSocket = () => {
      if (wsRef.current) return; // 이미 연결 중이면 재생성하지 않음

      const ws = new WebSocket(WS_URL);
      wsRef.current = ws;

      ws.onopen = () => {
        console.log("✅ 웹소켓 연결 성공:", WS_URL);
        ws.send(JSON.stringify({ type: "init", uid }));
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          switch (data.symbol) {
            case 'ETH/USDT:USDT':
              setEthCheck(data.start_check);
              setEthUsdt(data.total_usdt);
              break;
            case 'XRP/USDT:USDT':
              setXrpCheck(data.start_check);
              setXrpUsdt(data.total_usdt);
              break;
            case 'SOL/USDT:USDT':
              setSolCheck(data.start_check);
              setSolUsdt(data.total_usdt);
              break;
            case 'DOGE/USDT:USDT':
              setDogeCheck(data.start_check);
              setDogeUsdt(data.total_usdt);
              break;
            default:
              break;
          }
        } catch (err) {
          console.error("⚠️ JSON 파싱 오류:", err);
        }
      };

      ws.onerror = (error) => {
        console.error("❌ 웹소켓 에러:", error);
      };

      ws.onclose = (event) => {
        console.warn("🔌 웹소켓 연결 종료:", event.code, event.reason, event.wasClean);
        wsRef.current = null;
        const shouldRetry = event.code !== 1000; // 정상 종료(1000) 외에는 재시도
        const retryDelay = event.code === 426 ? 1000 : 5000;
        if (!isUnmounted && shouldRetry) {
          console.log(`🔁 ${retryDelay / 1000}초 후 재연결 시도...`);
          reconnectTimer = setTimeout(connectWebSocket, retryDelay);
        }
      };
    };

    connectWebSocket();

    // uid가 세팅되면 검색 함수 실행
    onClickSearch();

    return () => {
      isUnmounted = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, [uid]);


useEffect(() => {
    if (eth_check === "apply") {
      setIsTradingETH(true);
      setStatusTextETH("ETH 자동매매중...");
    } else {
      setIsTradingETH(false);
      setStatusTextETH("ETH 매매종료중");
    }
    if (xrp_check === "apply") {
      setIsTradingXRP(true);
      setStatusTextXRP("XRP 자동매매중...");
    } else {
      setIsTradingXRP(false);
      setStatusTextXRP("XRP 매매종료중");
    }
    if (sol_check === "apply") {
      setIsTradingSOL(true);
      setStatusTextSOL("SOL 자동매매중...");
    } else {
      setIsTradingSOL(false);
      setStatusTextSOL("SOL 매매종료중");
    }
    if (doge_check === "apply") {
      setIsTradingDOGE(true);
      setStatusTextDOGE("DOGE 자동매매중...");
    } else {
      setIsTradingDOGE(false);
      setStatusTextDOGE("DOGE 매매종료중");
    }
}, [eth_check, xrp_check, sol_check, doge_check]);

  //////////////////////////////////////////////////////////

  const[eth_usdt_Valid, setEthUsdtValid] = useState(true);
  const[xrp_usdt_Valid, setXrpUsdtValid] = useState(true);
  const[sol_usdt_Valid, setSolUsdtValid] = useState(true);
  const[doge_usdt_Valid, setDogeUsdtValid] = useState(true);
  const[notAllow, setNotAllow] = useState(true);

  // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //

  const handleEthUsdt = (e) => {
    const newusdt = e.target.value.trim();
    setEthUsdt(newusdt);

    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newusdt)) {
      setEthUsdtValid(true);
    } else {
      setEthUsdtValid(false);
    }
  };

  const handleXrpUsdt = (e) => {
    const newusdt = e.target.value.trim();
    setXrpUsdt(newusdt);

    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newusdt)) {
      setXrpUsdtValid(true);
    } else {
      setXrpUsdtValid(false);
    }
  };

  const handleSolUsdt = (e) => {
    const newusdt = e.target.value.trim();
    setSolUsdt(newusdt);

    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newusdt)) {
      setSolUsdtValid(true);
    } else {
      setSolUsdtValid(false);
    }
  };

  const handleDogeUsdt = (e) => {
    const newusdt = e.target.value.trim();
    setDogeUsdt(newusdt);

    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newusdt)) {
      setDogeUsdtValid(true);
    } else {
      setDogeUsdtValid(false);
    }
  };

  const handleEthCheck = (e) => {
    setEthCheck(e.target.value);
      };

  const handleXrpCheck = (e) => {
    setXrpCheck(e.target.value);
      };

  const handleSolCheck = (e) => {
    setSolCheck(e.target.value);
      };

  const handleDogeCheck = (e) => {
    setDogeCheck(e.target.value);
      };
  
  /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////

  useEffect(() => {

    if(eth_usdt_Valid && xrp_usdt_Valid && sol_usdt_Valid && doge_usdt_Valid
      ) {
      setNotAllow(false);
      return;
    }
    setNotAllow(true);
  }, [eth_usdt_Valid && xrp_usdt_Valid && sol_usdt_Valid && doge_usdt_Valid
    ]);

  /** DB 조회 1회 분을 그대로 입력란·체크에 반영 (같은 tick에서 setState, 비동기 onClickSearch보다 복원이 확실함) */
  const applyCoinRowsToState = (result) => {
    if (!result || !Array.isArray(result)) return;
    const eth = result.find((item) => item.symbol.startsWith("ETH/USDT"));
    const xrp = result.find((item) => item.symbol.startsWith("XRP/USDT"));
    const sol = result.find((item) => item.symbol.startsWith("SOL/USDT"));
    const doge = result.find((item) => item.symbol.startsWith("DOGE/USDT"));
    if (eth) {
      setEthUsdt(eth.total_usdt);
      setEthCheck(eth.start_check);
    }
    if (xrp) {
      setXrpUsdt(xrp.total_usdt);
      setXrpCheck(xrp.start_check);
    }
    if (sol) {
      setSolUsdt(sol.total_usdt);
      setSolCheck(sol.start_check);
    }
    if (doge) {
      setDogeUsdt(doge.total_usdt);
      setDogeCheck(doge.start_check);
    }
  };

  const onClickSearch = () => {
    if (!uid) return;
    console.log(uid);
    fetch(`/coin_search/${uid}`)
    .then((response) => {
      if(!response.ok) {
        throw new Error('400 아니면 500 에러남');
      }
      return response.json()
    })
    .then((result) => {
      console.log('db에서 성공적으로 데이터 받아옴');
      applyCoinRowsToState(result);
    })
    .catch((error) => {
      console.log('에러남');
    })
  }

  const onClickStart = (symbol) => {
    if (!uid) {
      alert("사용자 정보를 불러오는 중입니다. 잠시 후 다시 시도해 주세요.");
      return;
    }
    fetch(`/coin_search/${uid}`)
      .then(response => {
        if (!response.ok) throw new Error('서버 응답 실패');
        return response.json();
      })
      .then(result => {
        // 이번에 맞출 코인: 입력란 기준, 나머지 apply 코인: DB total_usdt (동일 코인 DB+입력 이중 합산 방지)
        let coin_usdt
        if (symbol === 'ETH/USDT:USDT'){
          coin_usdt = eth_usdt
        } else if (symbol === 'XRP/USDT:USDT'){
          coin_usdt = xrp_usdt
        } else if (symbol === 'SOL/USDT:USDT'){
          coin_usdt = sol_usdt
        } else if (symbol === 'DOGE/USDT:USDT'){
          coin_usdt = doge_usdt
        }
        const formVal = Number(coin_usdt);
        if (Number.isNaN(formVal)) {
          alert("올바른 숫자를 입력해 주세요.");
          applyCoinRowsToState(result);
          return;
        }

        const otherApplyUsdt = result
          .filter(
            (item) =>
              item.start_check === "apply" && item.symbol !== symbol
          )
          .reduce((sum, item) => sum + Number(item.total_usdt), 0);
        const totalForLimit = otherApplyUsdt + formVal;
        console.log("등급 한도용 합계(타 코인 apply DB + 이 코인 입력):", totalForLimit);
        
        let compare_usdt
        if (grade === 'normal'){
          compare_usdt = 0
        } else if(grade === 'silver'){
          compare_usdt = 150
        } else if(grade === 'gold'){
          compare_usdt = 700
        } else if(grade === 'diamond'){
          compare_usdt = 99999999999
        }

        if (totalForLimit >= compare_usdt) {
          alert(`${nickname}님은 ${compare_usdt}까지 셋팅 가능합니다. 현재 셋팅 합은 ${totalForLimit}입니다.`);
          applyCoinRowsToState(result);
          return; // 여기서 바로 함수 종료
        }
        // 여기는 total_check < compare_usdt일 때만 실행됨
        setSymbol(symbol);
        setConfirmMessage(`${symbol} 셋팅값으로 매매를 진행할까요?`);
        setShowConfirm(true);
      })
      .catch(error => {
        console.error("데이터 처리 중 에러 발생:", error);
      });
  };
  
  const handleCancel = () => {
    setShowConfirm(false);
    console.log('매매 취소');
    onClickSearch();
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    console.log(symbol + ' 셋팅값으로 매매를 진행합니다.');
      let coin_usdt
      if (symbol === 'ETH/USDT:USDT'){
        coin_usdt = eth_usdt
      } else if (symbol === 'XRP/USDT:USDT'){
        coin_usdt = xrp_usdt
      } else if (symbol === 'SOL/USDT:USDT'){
        coin_usdt = sol_usdt
      } else if (symbol === 'DOGE/USDT:USDT'){
        coin_usdt = doge_usdt
      }

      if (coin_usdt <= 0 ){
        window.alert('양수만 입력가능합니다.');
        onClickSearch();
        return;
      }
      fetch('/set_start_symbol', {
        method : 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({
          uid,
          symbol,
          coin_usdt
          }),
        })
        .then(response => response.json())  // 응답을 JSON 형식으로 변환
        .then(data => {
        onClickSearch();
        })
        .catch(error => console.error('Error:', error));
    };

  const onClickStop = (symbol) => {
    setSymbol(symbol);          // 어떤 심볼인지 저장
    setConfirmMessage(`${symbol} 매매를 종료할까요?`);
    setShowConfirmStop(true);       // 확인창 표시
  };

  const handleCancelStop = () => {
    setShowConfirmStop(false);
    console.log('종료 취소');
  };

  const handleConfirmStop = () => {
    setShowConfirmStop(false);
    console.log(symbol + ' 매매를 종료합니다.');
    console.log('코인 종료 클릭')
    fetch('/set_start_symbol_stop', {
      method : 'POST',
      headers: {
        'Content-Type' : 'application/json',
      },
      body: JSON.stringify({
        uid,
        symbol
        }),
      })
      .then(response => response.json())  // 응답을 JSON 형식으로 변환
      .then(data => {
        setConfirmMessage(data.message)
        setShowConfirmStopYes(true);
      onClickSearch();
      })
      .catch(error => console.error('Error:', error));
  };

  const handleConfirmStopYes= () => {
    setShowConfirmStopYes(false);
    console.log('포지션 정리 확인');
  };

  //로그아웃
  const onClickEnd = () => {
    const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
    if (!uuid) {
      alert('로그인 정보가 존재하지 않습니다.');
      return;
    }
    // 로그아웃 요청을 서버로 보냅니다.
    fetch('/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId: uuid })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('로그아웃 요청 실패');
      }
      console.log('로그아웃 성공');
      alert('Logout is successful.');
      window.location.href = '/';
    })
    .catch(error => {
      console.error('로그아웃 요청 중 오류 발생:', error);
    });
    // UUID를 서버로 보내는 예시 코드
  }

  return (
      <div style={styles.page}>
        <div style={styles.container}>
          <div style={styles.headerRow}>
            <div style={styles.titleWrap}>
              <span style={styles.badge}>Speed BOT</span>
              <h1 style={styles.title}>Auto Trade System</h1>
              <p style={styles.helper}>실시간 시그널과 자동매매 상태를 확인하세요.</p>
            </div>
            <div style={styles.tagRow}>
              <span style={styles.tag}>UID: {uid}</span>
              <span style={styles.tag}>GRADE: {grade?.toUpperCase() || "-"}</span>
              <span style={styles.tag}>사용기한: {ex_period || "-"}</span>
              <span style={styles.tag}>Nickname: {nickname || "-"}</span>
              <span style={styles.tag}>{email || "-"}</span>
              <button
                style={{
                  padding: "10px 12px",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.12)",
                  background: "rgba(255,255,255,0.06)",
                  color: "#f8fafc",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                onClick={() => navigate("/SelectPage")}
              >
                ← SelectPage
              </button>
            </div>
          </div>

          <div className="container" style={styles.card}>
            <div className="column_leverage">
            <h1 style={styles.title}>WEB version</h1>
            <div className="line"></div>
              {/* ✅ 자동매매 상태 표시 */}
              <div className={`trading-status ${isTradingETH ? 'active' : 'inactive'}`}>
                <span className={`pulse-dot ${isTradingETH ? 'active' : 'inactive'}`}></span>
                <span className="trading-text">{statusTextETH}</span>
              </div>
              <div className="leverage_container">
              <div className="leverage_item">이더리움(ETH)</div>
              <div className="leverage_item">USDT</div>
                <div className="tooltip_wrapper">
                  <input 
                    type="number"
                    step="1"
                    className="leverage_input_basic"
                    value={eth_usdt}
                    disabled={eth_check === 'apply'}
                    onChange={handleEthUsdt}
                  />
                  {eth_check === 'apply' && (
                    <div className="tooltip_message">
                      셋팅값 변경은 매매종료 후 가능합니다.
                    </div>
                  )}
                </div>
              </div>
              <div className="leverage_container">
                <button onClick={() => onClickStart('ETH/USDT:USDT')} disabled={eth_check === 'apply'} className="button_benefit_c_lever">
                  매매시작
                </button>
                <button onClick={() => onClickStop('ETH/USDT:USDT')} className="button_benefit_c_lever">
                  매매종료
                </button>
            </div>

            <div className="line"></div>

              {/* ✅ 자동매매 상태 표시 */}
              <div className={`trading-status ${isTradingXRP ? 'active' : 'inactive'}`}>
                <span className={`pulse-dot ${isTradingXRP ? 'active' : 'inactive'}`}></span>
                <span className="trading-text">{statusTextXRP}</span>
              </div>
            <div className="leverage_container">
                <div className="leverage_item">리플(XRP)</div>
              <div className="leverage_item">USDT</div>
                <input 
                  type="number"
                  step="1"
                  className="leverage_input_basic"
                  value={xrp_usdt}
                  disabled={xrp_check === 'apply'}
                  onChange={handleXrpUsdt} />
              </div>
              <div className="leverage_container">
                <button onClick={() => onClickStart('XRP/USDT:USDT')} disabled={xrp_check === 'apply'} className="button_benefit_c_lever">
                  매매시작
                </button>
                <button onClick={() => onClickStop('XRP/USDT:USDT')} className="button_benefit_c_lever">
                  매매종료
                </button>
            </div>

            <div className="line"></div>
            
            {/* ✅ 자동매매 상태 표시 */}
            <div className={`trading-status ${isTradingSOL ? 'active' : 'inactive'}`}>
              <span className={`pulse-dot ${isTradingSOL ? 'active' : 'inactive'}`}></span>
              <span className="trading-text">{statusTextSOL}</span>
            </div>

            <div className="leverage_container">
                <div className="leverage_item">솔라나(SOL)</div>
              <div className="leverage_item">USDT</div>
                <input 
                  type="number"
                  step="1"
                  className="leverage_input_basic"
                  value={sol_usdt}
                  disabled={sol_check === 'apply'}
                  onChange={handleSolUsdt} />
              </div>
              <div className="leverage_container">
                <button onClick={() => onClickStart('SOL/USDT:USDT')} disabled={sol_check === 'apply'} className="button_benefit_c_lever">
                  매매시작
                </button>
                <button onClick={() => onClickStop('SOL/USDT:USDT')} className="button_benefit_c_lever">
                  매매종료
                </button>
            </div>

            <div className="line"></div>

            {/* ✅ 자동매매 상태 표시 */}
            <div className={`trading-status ${isTradingDOGE ? 'active' : 'inactive'}`}>
              <span className={`pulse-dot ${isTradingDOGE ? 'active' : 'inactive'}`}></span>
              <span className="trading-text">{statusTextDOGE}</span>
            </div>
            <div className="leverage_container">
                <div className="leverage_item">도지(DOGE)</div>
              <div className="leverage_item">USDT</div>
                <input 
                  type="number"
                  step="1"
                  className="leverage_input_basic"
                  value={doge_usdt}
                  disabled={doge_check === 'apply'}
                  onChange={handleDogeUsdt} />
              </div>
              <div className="leverage_container">
                <button onClick={() => onClickStart('DOGE/USDT:USDT')} disabled={doge_check === 'apply'} className="button_benefit_c_lever">
                  매매시작
                </button>
                <button onClick={() => onClickStop('DOGE/USDT:USDT')} className="button_benefit_c_lever">
                  매매종료
                </button>
            </div>

          <div className="line"></div>
          <div className="button_benefit_leverage">
              <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
              로그아웃
              </button>
            </div>
          </div>
        </div>
      
        {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p className="confirm-message">
              {confirmMessage}
            </p>
            <div className="confirm-buttons">
              <button className="confirm-btn yes" onClick={handleConfirm}>확인</button>
              <button className="confirm-btn no" onClick={handleCancel}>취소</button>
            </div>
          </div>
        </div>
      )}

      {showConfirmStop && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p className="confirm-message">
              {confirmMessage}
            </p>
            <div className="confirm-buttons">
              <button className="confirm-btn yes" onClick={handleConfirmStop}>확인</button>
              <button className="confirm-btn no" onClick={handleCancelStop}>취소</button>
            </div>
          </div>
        </div>
      )}

      {showConfirmStopYes && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <p className="confirm-message">
                {confirmMessage}
              </p>
              <div className="confirm-buttons">
                <button className="confirm-btn yes" onClick={handleConfirmStopYes}>확인</button>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
  );
}